module.exports = __webpack_public_path__ + "components/MapHeader/img/x.png?33e5b09e";


//////////////////
// WEBPACK FOOTER
// ./components/MapHeader/img/x.png
// module id = 2191
// module chunks = 0